import { render, staticRenderFns } from "./type2Detail.vue?vue&type=template&id=7237bf66&scoped=true"
import script from "./type2Detail.vue?vue&type=script&lang=js"
export * from "./type2Detail.vue?vue&type=script&lang=js"
import style0 from "./type2Detail.vue?vue&type=style&index=0&id=7237bf66&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7237bf66",
  null
  
)

export default component.exports